import { toast, ToastOptions } from "react-toastify";

let id: any;

export const loadingToast = (message: string) => {
  id = toast.loading(message, {
    style: {
      fontFamily: "Poppins",
    },
  });
};

export const successToast = (message: string, options?: ToastOptions) => {
  if (id) {
    toast.update(id, {
      render: message,
      type: "success",
      isLoading: false,
      autoClose: 1500,
      style: {
        fontFamily: "Poppins",
      },
      ...options,
    });
    id = null;
  } else {
    toast.success(message, {
      autoClose: 1500,
      style: {
        fontFamily: "Poppins",
      },
      ...options,
    });
  }
};

export const errorToast = (message: string, options?: ToastOptions) => {
  if (!message) return;

  if (id) {
    toast.update(id, {
      render: message,
      type: "error",
      isLoading: false,
      autoClose: 3500,
      style: {
        fontFamily: "Poppins",
      },
      ...options,
    });
    id = null;
  } else {
    toast.error(message, {
      autoClose: 3500,
      style: {
        fontFamily: "Poppins",
      },
      toastId: message,
      ...options,
    });
  }
};

export const infoToast = (message: string, options?: ToastOptions) => {
  if (id) {
    toast.update(id, {
      render: message,
      type: "info",
      isLoading: false,
      autoClose: 1500,
      style: {
        fontFamily: "Poppins",
      },
      ...options,
    });
    id = null;
  } else {
    toast.info(message, {
      autoClose: 1500,
      style: {
        fontFamily: "Poppins",
      },
      ...options,
    });
  }
};

export const warnToast = (message: string, options?: ToastOptions) => {
  if (id) {
    toast.update(id, {
      render: message,
      type: "warning",
      isLoading: false,
      autoClose: 1500,
      style: {
        fontFamily: "Poppins",
      },
      ...options,
    });
    id = null;
  } else {
    toast.warn(message, {
      autoClose: 1500,
      style: {
        fontFamily: "Poppins",
      },
      ...options,
    });
  }
};

export const dismissAllToasts = () => {
  toast.dismiss();
};

export const handleAPIErrorToast = (error: any) => {
  if (error && error?.response?.status === 404) {
    return errorToast("Not Found");
  }
  if (error && error?.response?.status === 401) {
    return errorToast("Unauthorized");
  }
  if (error && error?.response?.status === 403) {
    return errorToast(
      "To keep your account secure, we need you to sign in again. Please log in to continue.",
      {
        autoClose: 5500,
      }
    );
  }
  return errorToast(error?.response?.data?.message || error?.message);
};
